"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEditorErrorToMonacoDecoration = void 0;
const monaco = __importStar(require("monaco-editor"));
const Colors_1 = require("../../../Colors");
exports.mapEditorErrorToMonacoDecoration = (e) => ({
    range: new monaco.Range(e.row + 1, 1, e.row + 1, 1000),
    options: {
        className: 'monacoError',
        isWholeLine: true,
        minimap: {
            color: Colors_1.Colors.red[0],
            position: 1,
        },
        hoverMessage: [
            {
                value: e.text,
            },
        ],
        glyphMarginHoverMessage: {
            value: e.text,
        },
        glyphMarginClassName: 'monacoMarginError',
    },
});
